import React from 'react';

import { useDeleteChannelFromCompany } from '@/features/company';

import { TModeCompanyDialog, TSelectCompanyFormData } from '../../model/types';
import { useAddChannelToCompany } from '../../model/useAddChannelToCompany';
import { useTransferChannelToNewCompany } from '../../model/useTransferChannelToCompany';

import {
  ISelectCompanyDialogProps,
  SelectCompanyDialog,
} from './SelectCompanyDialog';

type AddCompanyToChannelDialogProps = Omit<
  ISelectCompanyDialogProps,
  'onSubmit'
> & {
  channelId: string;
  companyId?: string;
  mode?: TModeCompanyDialog;
};

export const AddChannelToCompanyDialog = ({
  open,
  onClose,
  channelId,
  companyId,
  mode,
}: AddCompanyToChannelDialogProps) => {
  const { addChannelToCompany, isPending: isPendingAddChannelToCompany } =
    useAddChannelToCompany();

  const { transferChannelToCompany, isPending: isPendingTransfer } =
    useTransferChannelToNewCompany();

  const { deleteChannelFromCompany, isPending: isPendingDelete } =
    useDeleteChannelFromCompany();

  const onSubmit = async (data: TSelectCompanyFormData) => {
    if (!channelId) return;

    if (!data.companyId) {
      if (companyId) {
        await deleteChannelFromCompany(companyId, channelId);
      }
      onClose?.();
      return;
    }

    if (data.companyId === companyId) {
      onClose?.();
      return;
    }

    if (companyId) {
      await transferChannelToCompany(
        {
          companyId,
          channelId,
          params: { new_company_id: data.companyId },
        },
        onClose
      );
    } else {
      await addChannelToCompany(
        {
          companyId: data.companyId,
          channelId,
        },
        onClose
      );
    }
  };

  return (
    <SelectCompanyDialog
      open={open}
      onClose={onClose}
      isPending={
        isPendingAddChannelToCompany || isPendingTransfer || isPendingDelete
      }
      onSubmit={onSubmit}
      currentCompanyId={companyId}
      mode={mode}
    />
  );
};
